<template>
  <div>
    <!--<textarea v-model="content"></textarea>-->
    <!--<button @click="click">create link</button>-->
  </div>
</template>

<script>
  import { MessageBox } from 'element-ui';
  import {originconfig} from "../../../static/apiConfig/originConfig";

  export default {
    props: ['onMessage', 'pageType'],
    name: 'websocket',
    data() {
      return {
        content: 123,
        websocket: null,
      }
    },
    methods: {
      click() {
        console.log(this.content);
        this.websocketsend(this.content);
      },
      threadPoxi() {  // 实际调用的方法
        //参数
        const agentData = "mymessage";
        //若是ws开启状态
        if (this.websocket.readyState === this.websocket.OPEN) {
          this.websocketsend(agentData)
        }
        // 若是 正在开启状态，则等待300毫秒
        else if (this.websocket.readyState === this.websocket.CONNECTING) {
          let that = this;//保存当前对象this
          setTimeout(function () {
            that.websocketsend(agentData)
          }, 300);
        }
        // 若未开启 ，则等待500毫秒
        else {
          this.initWebSocket();
          let that = this;//保存当前对象this
          setTimeout(function () {
            that.websocketsend(agentData)
          }, 500);
        }
      },
      initWebSocket() { //初始化websocket
        //ws地址

        // const httpUri = window.location.origin;
        // const httpUri = 'http://localhost:8889';
        // const httpUri = 'http://172.16.40.36:8889';
        // const wsuri = httpUri.replace("http", "ws") + "/websocket?pageType=" + (this.$props.pageType ? this.$props.pageType : 0);

        const httpUri = window.location.origin;
        // const httpUri = 'http://localhost:8889';
        const wsUrl = httpUri.replace("http", "ws") + originconfig.domain + "/websocket?pageType=" + (this.$props.pageType ? this.$props.pageType : 0);
        this.websocket = new WebSocket(wsUrl);
        this.websocket.onopen = this.websocketonopen;
        this.websocket.onmessage = this.websocketonmessage;
        this.websocket.onclose = this.websocketclose;
      },
      websocketonopen(e) {
        console.log('connection initialized');
      },
      websocketonmessage(e) { //数据接收
        // console.log("收到数据", e);
        const redata = JSON.parse(e.data);
        if (this.onMessage && this.onMessage instanceof Function) {
          this.onMessage(redata);
        }
      },
      websocketsend(agentData) {//数据发送
        this.websocket.send(agentData);
      },
      websocketclose(e) {  //关闭
        console.log("connection closed (" + e.code + ")");
      }
    },
    mounted() {
      this.initWebSocket();
    },
    beforeDestroy() {
      this.websocket.close();
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/websocket/websocket.vue